import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  joinMemberData: {},
  error: "",
  success: false,
  status: "",
};

const joinMemberCall = createAsyncThunk(
  "post/join-member",
  async ({ data, entityId }) => {
   
    try {
      const result = await axios.post(
        `https://apac-apigateway.capillarytech.com/mobile/v2/api/userGroup2/join?id=${entityId}`,
        data
      );

      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const joinMemberSlice = createSlice({
  name: "join-member",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.joinMemberData = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(joinMemberCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(joinMemberCall.fulfilled, (state, action) => {
      state.loading = false;
      state.joinMemberData = action.payload;
      // state.success = action.payload?.status?.success === "true" ? true : false;
      // state.status = action.payload?.status?.code;
      // state.message = action.payload?.status?.message;
      state.error = "";
    });
    builder.addCase(joinMemberCall.rejected, (state, action) => {
      state.loading = false;
      state.joinMemberData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default joinMemberSlice.reducer;
export const { reset } = joinMemberSlice.actions;
export { joinMemberCall };
